import { Component, model, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'mbp-search',
  templateUrl: './search.component.html',
  styleUrl: './search.component.scss',
  imports: [TranslateModule]
})
export class SearchComponent {
  searchTerm = model<string>('');
  placeholder = input<string>();

  protected onSearchChange(value: string): void {
    this.searchTerm.set(value);
  }
}
